import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild, inject, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { BsLocaleService, BsDatepickerInputDirective, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription, timer } from 'rxjs';
import { fadeAnimation } from 'src/app/animations/fade-animations';
import { fadeInAnimation } from 'src/app/animations/fade-in-animation';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ChatService } from 'src/app/services/chat/chat.service';
import { DirectoryService } from 'src/app/services/directory/directory.service';
import { LinksService } from 'src/app/services/links/links.service';
import { MenuService } from 'src/app/services/menu/menu.service';
import { NotificationCenterService } from 'src/app/services/notification-center/notification-center.service';
import { PodService } from 'src/app/services/pod/pod.service';
import { SearchService } from 'src/app/services/search/search.service';
import { UserDataService } from 'src/app/services/userData/user-data.service';
import { UtilService } from 'src/app/services/util/util.service';
import { CookieMessageComponent } from '../cookie-message/cookie-message.component';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { NotificationCenterComponent } from '../notification-center/notification-center.component';
import { OneSignal } from 'onesignal-ngx';
import { BsDropdownConfig, BsDropdownDirective, BsDropdownToggleDirective, BsDropdownMenuDirective } from 'ngx-bootstrap/dropdown';
import { IconComponent } from '../icon/icon.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { NgStyle, NgClass, DatePipe } from '@angular/common';
import { PerfectScrollbarDirective } from 'ngx-perfect-scrollbar-portable';
import { SearchOverlayComponent } from '../search-overlay/search-overlay.component';
import { FormGroupDirective } from '../../directives/formGroup/form-group.directive';
import { NgSelectComponent, NgOptionComponent, NgLabelTemplateDirective, NgOptionTemplateDirective } from '@ng-select/ng-select';
import { MatTooltip } from '@angular/material/tooltip';
import { PasswordStrengthInfoComponent } from '../password-strength-info/password-strength-info.component';
import { UserDisplayComponent } from '../user-display/user-display.component';
import { BhTimepickerComponent } from '../bh-timepicker/bh-timepicker.component';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

@Component({
    selector: 'app-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    animations: [fadeInAnimation, fadeAnimation],
    providers: [{ provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } }],
    imports: [IconComponent, SvgIconComponent, RouterLink, MatMenu, MatMenuContent, MatMenuItem, MatIconButton, MatMenuTrigger, BsDropdownDirective, BsDropdownToggleDirective, NgStyle, NgClass, BsDropdownMenuDirective, PerfectScrollbarDirective, FormsModule, SearchOverlayComponent, NotificationCenterComponent, ErrorModalComponent, ModalDirective, ReactiveFormsModule, FormGroupDirective, NgSelectComponent, NgOptionComponent, MatTooltip, PasswordStrengthInfoComponent, CookieMessageComponent, UserDisplayComponent, NgLabelTemplateDirective, NgOptionTemplateDirective, BsDatepickerInputDirective, BsDatepickerDirective, BhTimepickerComponent, DatePipe, TranslatePipe, UserAvatarComponent]
})
export class HeaderComponent implements OnInit, OnDestroy {
  util = inject(UtilService);
  menu = inject(MenuService);
  auth = inject(AuthService);
  ds = inject(DirectoryService);
  uds = inject(UserDataService);
  ss = inject(SearchService);
  cs = inject(ChatService);
  router = inject(Router);
  formBuilder = inject(FormBuilder);
  translate = inject(TranslateService);
  localeService = inject(BsLocaleService);
  notificationCenterService = inject(NotificationCenterService);
  private cdr = inject(ChangeDetectorRef);

  @Output() requestConsentmentTerm = new EventEmitter<void>();
  ps = inject(PodService);
  ls = inject(LinksService);
  oneSignal = inject(OneSignal);

  @ViewChild('errorModal') errorModal: ErrorModalComponent;
  @ViewChild('editLocaleModal') editLocaleModal: ModalDirective;
  @ViewChild('enablePush') enablePush: ModalDirective;
  @ViewChild('editPasswordModal') editPasswordModal: ModalDirective;
  @ViewChild('notificationCenter') notificationCenter: NotificationCenterComponent;
  @ViewChild('cookie') cookie: CookieMessageComponent;
  @ViewChild('selectAvatarModal') selectAvatarModal: ModalDirective;
  @ViewChild('editStatusModal') editStatusModal: ModalDirective;
  savingLocale = false;
  localeForm: FormGroup;
  savingPassword = false;
  passwordForm: FormGroup;
  passwordStrength: any = { value: null, label: '' };
  darkMode: any;
  newsManager = false;
  videowallManager = false;
  chatbotManager = false;
  welcomeScreenManager = false;
  weakPassword = false;
  updatingCache = false;
  avatar: any;
  previousUser: any;
  showPasswordCurrent: boolean;
  showPasswordNew: boolean;
  showPasswordRepeat: boolean;
  passErrorBlackList: any;
  changingToFromAvatar = false;
  notAllowedPassword = false;
  dropdownOpen = false;
  tenant = ""

  // chat availability status
  chatAvailabilityStatusList: any[] = [];
  selectedChatUserAvailabilityStatus: any = null;
  selectedChatUserAvailabilityCustomMessage = '';
  selectedChatUserAvailabilityExpiresOn: Date | null = null;
  selectedChatUserAvailabilityExpiresDate: Date | null = null;
  selectedChatUserAvailabilityExpiresTime: Date | null = null;
  expiresPreset: '10m' | '1h' | '2h' | 'eod' | 'custom' | null = null;
  expiresOptions = [
    { value: null,      label: 'Não expirar' },
    { value: '10m',     label: 'Em 10 minutos' },
    { value: '1h',      label: 'Em 1 hora' },
    { value: '2h',      label: 'Em 2 horas' },
    { value: 'eod',     label: 'Até o fim do dia' },
    { value: 'custom',  label: 'Personalizado...' }
  ];
  private chatAvailabilityExpirationSubscription: Subscription | null = null;

  constructor() {
    this.tenant = this.util.configuration.tenantId
    if (localStorage.getItem('isPushNotificationsEnabled')) {
      const storedValue = localStorage.getItem('isPushNotificationsEnabled');
      this.util.isPushNotificationsEnabled = (storedValue === 'true');
    }

    this.localeForm = this.formBuilder.group({
      preferredLocale: [null, Validators.compose([Validators.required])],
    });
    this.passwordForm = this.formBuilder.group({
      currentPassword: [null, Validators.compose([Validators.required])],
      newPassword: [null, Validators.compose([Validators.required])],
      repeatPassword: [null, Validators.compose([Validators.required])],
      hasError: false
    });
    this.darkMode = localStorage.getItem('dark-mode');
  }

  ngOnInit(): void {
    // Zoneless: detectChanges() é síncrono, markForCheck() não é confiável
    // em callbacks externos (socket/HTTP). Garante re-render imediato do badge
    // de mensagens não lidas (mesmo padrão da sidebar).
    this.menu.unreadUpdated$.subscribe(() => {
      this.cdr.detectChanges();
    });
    this.passwordForm.controls.newPassword.valueChanges.subscribe(value => {
      this.notAllowedPassword = false;
      this.cdr.markForCheck();
    });
    this.util.getBasicOperation('MANAGER_NEWS').subscribe((data: any) => {
      this.newsManager = data;
      this.cdr.markForCheck();
    });
    this.util.getBasicOperation('MANAGER_VIDEOWALL').subscribe((data: any) => {
      this.videowallManager = data;
      this.cdr.markForCheck();
    });
    this.util.getBasicOperation('MANAGER_CHATBOT').subscribe((data: any) => {
      this.chatbotManager = data;
      this.cdr.markForCheck();
    });
    this.util.getBasicOperation('MANAGER_WELCOME_SCREEN').subscribe((data: any) => {
      this.welcomeScreenManager = data;
      this.cdr.markForCheck();
    });
    this.menu.isManagerDashboard();
    this.getPodHeader();
    this.previousUser = JSON.parse(localStorage.getItem('previousUser'));
    this.getCurrentChatUserAvailabilityStatus();
  }

  ngOnDestroy(): void {
    this.clearChatAvailabilityExpirationObserver();
  }

  onShown(): void {
    if (!this.dropdownOpen) {
      this.dropdownOpen = true;
      this.ds.listUserAvatars().subscribe(() => { this.cdr.markForCheck(); });
    }
  }

  repromptForNotifications() {
    this.oneSignal.getNotificationPermission()
      .then((permission: any) => {
        if (permission === 'default') {
          return this.oneSignal.showNativePrompt();
        } else if (permission === 'denied') {
          this.enablePush.show();
        } else if (permission === 'granted') {
          // permission already granted
        }
      })
      .then((_nativeData: any) => {
      })
      .catch((error: any) => {
        console.error('Error re-prompting for notifications:', error);
      });
  }

  openConsentmentTerm() {
    this.requestConsentmentTerm.emit();
  }

  searchToggle() {
    this.ss.toggleSearch();
  }

  showNotifications() {
    this.notificationCenter.show();
  }

  toggleDarkMode() {
    this.util.document.body.classList.toggle('dark-mode');
    if (localStorage.getItem('dark-mode')) {
      localStorage.setItem('dark-mode', '');
    } else {
      localStorage.setItem('dark-mode', 'dark-mode');
    }
    this.util.darkMode = localStorage.getItem('dark-mode');
    // Avisa iframes embarcados (Luck) para acompanharem o toggle em tempo real.
    this.util.darkMode$.next(!!this.util.darkMode);
  }

  editLocaleToogle() {
    this.localeForm.patchValue({ preferredLocale: this.menu.loggedUser.preferredLocale });
    this.editLocaleModal.show();
  }

  editLocale() {
    if (this.localeForm.valid) {
      this.savingLocale = true;
      this.ds.editPreferredLocale(this.localeForm.get('preferredLocale').value).subscribe((data: any) => {
        if (this.localeForm.get('preferredLocale').value.indexOf('es') !== -1) {
          this.translate.setFallbackLang('es');
          this.translate.use('es');
          this.localeService.use('es');
        } else if (this.localeForm.get('preferredLocale').value.indexOf('en') !== -1) {
          this.translate.setFallbackLang('en');
          this.translate.use('en');
          this.localeService.use('en');
        } else if (this.localeForm.get('preferredLocale').value.indexOf('pt-PT') !== -1) {
          this.translate.setFallbackLang('pt-PT');
          this.translate.use('pt-PT');
          this.localeService.use('pt-PT');
        } else {
          this.translate.setFallbackLang('pt-BR');
          this.translate.use('pt-BR');
          this.localeService.use('pt-BR');
        }
        this.menu.loggedUser.preferredLocale = this.localeForm.get('preferredLocale').value;
        const loggedUserValue = JSON.stringify(this.menu.loggedUser);
        localStorage.setItem('loggedUser', loggedUserValue);
        this.editLocaleModal.hide();
        this.savingLocale = false;
        this.cdr.markForCheck();
        window.location.reload();
        setTimeout(() => {
          this.util.getEmojiLabelsTranslated();
        }, 600);
      }, _ => {
        this.savingLocale = false;
        this.editLocaleModal.hide();
        this.errorModal.show();
        this.cdr.markForCheck();
      });
    } else {
      this.util.markAsDirty(this.localeForm);
    }
  }

  getFormControl(name, form) {
    if (form) {
      return form.controls[name];
    }
  }

  editPasswordToogle() {
    this.passwordForm.reset();
    this.weakPassword = false;
    this.notAllowedPassword = false;
    this.editPasswordModal.show();
  }

  ediPassword() {
    this.passErrorBlackList = false;
    this.util.getPassWordBlackList().subscribe((data: any) => {
      for (let wordBlackList of this.util.passwordBalckList) {
        if (!wordBlackList.caseSensitive) {
          if (this.passwordForm.value.newPassword.toLowerCase().indexOf(wordBlackList.word.toLowerCase()) != -1) {
            this.passErrorBlackList = true;
            break;
          };
        } else {
          if (this.passwordForm.value.newPassword.indexOf(wordBlackList.word) != -1) {
            this.passErrorBlackList = true;
            break;
          };
        }
      }
      if (this.passwordForm.valid && this.passwordIsValid() && !this.passErrorBlackList) {
        if (this.passwordStrength.value >= this.util.configuration.passwordStrength) {
          this.savingPassword = true;
          this.passwordForm.patchValue({ hasError: false });
          this.ds.checkPassword({ id: this.menu.loggedUserId, password: this.passwordForm.get('currentPassword').value }).subscribe((validPassword: any) => {
            if (validPassword) {
              this.ds.editPassword({ id: this.menu.loggedUserId, password: this.passwordForm.get('newPassword').value }, true).subscribe((data: any) => {
                const user = this.menu.loggedUser;
                user.password = this.passwordForm.get('newPassword').value;
                this.ds.updateToken(user).subscribe((result: any) => {
                  if (result && result.token) {
                    this.util.setJWT(result.token);
                  }
                  this.editPasswordModal.hide();
                  this.savingPassword = false;
                  this.cdr.markForCheck();
                });
              }, err => {
                this.savingPassword = false;
                if (err.error == 'Senha já utilizada nas últimas 3 alterações' || err.error == 'PasswordHistoryPolicyViolationException') {
                  this.notAllowedPassword = true;
                } else if (err.error == 'InvalidPasswordException') {
                  this.weakPassword = true;
                } else {
                  this.editPasswordModal.hide();
                  this.errorModal.show();
                }
                this.cdr.markForCheck();
              });
            } else {
              this.savingPassword = false;
              this.passwordForm.patchValue({ hasError: true });
              this.cdr.markForCheck();
            }
          }, _ => {
            this.savingPassword = false;
            this.editPasswordModal.hide();
            this.errorModal.show();
            this.cdr.markForCheck();
          });
        } else {
          this.weakPassword = true;
        }
      } else {
        this.util.markAsDirty(this.passwordForm);
      }
    })
  }

  passwordIsValid(): boolean {
    return this.passwordForm.get('newPassword').value === this.passwordForm.get('repeatPassword').value;
  }

  onStrengthChange(ev?) {
    this.passErrorBlackList = false;
    if (ev != null && ev >= -1) {
      this.weakPassword = false;
      switch (ev) {
        case 0:
          this.passwordStrength.label = 'Muito fácil';
          break;
        case 1:
          this.passwordStrength.label = 'Fácil';
          break;
        case 2:
          this.passwordStrength.label = 'Bom';
          break;
        case 3:
          this.passwordStrength.label = 'Muito bom';
          break;
        case 4:
          this.passwordStrength.label = 'Excelente';
          break;
        default:
          break;
      }
      this.passwordStrength.value = ev;
    }
  }

  favoriteLinks: any[] = [];
  linksLoaded = false;
  linksLoading = true;
  loadLinksOnce() {
    if (this.linksLoaded) {
      return;
    }

    this.ls.listLinkUserHistory().subscribe((data: any) => {
      this.favoriteLinks = data;
      this.linksLoaded = true;
      this.linksLoading = false;
      this.cdr.markForCheck();
    },
      err => {
        console.error('Erro ao carregar links', err);
      }
    );
  }

  listLinkUserHistory() {
    this.ls.listLinkUserHistory().subscribe((_: any) => {
      this.cdr.markForCheck();
    }, _ => {
    });
  }

  getPodHeader() {
    this.ps.getPodHeader().subscribe((_: any) => {
      this.cdr.markForCheck();
    }, _ => {
    });
  }

  saveLinkUserHistory(link) {
    window.open(link.url, '_blank');
    this.ls.saveLinkUserHistory(link.id).subscribe((_: any) => {
      this.listLinkUserHistory();
      this.cdr.markForCheck();
    }, _ => {
    });
  }

  showCookieSlider() {
    this.cookie.show();
  }

  selectAvatarToogle() {
    this.selectAvatarModal.show();
  }

  async selectAvatar() {
    try {
      this.changingToFromAvatar = true;
      
      await this.ds.loginAvatar(this.avatar.id).toPromise();
      await this.menu.getLoggedUser();
      this.menu.loggedUserId = null;
      await this.menu.getLoggedUserId();
      this.previousUser = JSON.parse(localStorage.getItem('previousUser'));
      await this.menu.getLeftMenu();
      this.selectAvatarModal.hide();
      await this.router.navigate(['/beezz']);
      setTimeout(() => {
        window.location.reload();
      }, 100);
      
    } catch (error) {
      this.selectAvatarModal.hide();
      this.errorModal.show();
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } finally {
      this.changingToFromAvatar = false;
    }
  }

  async returnToUser() {
     if (!this.previousUser || !this.previousUser.id) {
       this.errorModal.show();
       return;
     }

     if (this.changingToFromAvatar) {
       return;
     }

    try {
      this.changingToFromAvatar = true;
      await this.ds
        .logoffAvatar(this.previousUser.id, this.menu.loggedUserId)
        .toPromise();
      await this.menu.getLoggedUser();
      this.menu.loggedUserId = null;
      this.menu.getLoggedUserId();
      this.previousUser = null;
      this.menu.getLeftMenu();
      this.selectAvatarModal.hide();
      await this.router.navigate(["/beezz"]);

      let tm = setTimeout(() => {
        window.location.reload();
        clearTimeout(tm);
      }, 100);
    } catch (error) {
      console.error("Erro ao retornar para usuário:", error);
      this.changingToFromAvatar = false;
      this.selectAvatarModal.hide();
      this.errorModal.show();

      let tm = setTimeout(() => {
        window.location.reload();
        clearTimeout(tm);
      }, 2000);
    } finally {
      this.changingToFromAvatar = false;
    }
  }

  goToPod(pod) {
    if (pod?.podType !== 'wikiPage' && pod?.podType !== 'customLink' && pod?.podType !== 'blogPost' && pod?.podType !== 'urlIntegration' && pod?.podType !== 'internalLink') {
      this.router.navigateByUrl(`/${pod?.podType}`);
    }
    else if (pod?.podType === 'wikiPage') {
      this.router.navigateByUrl(`/wiki/${pod?.wikiId}/detail`);
    }
    else if (pod?.podType === 'blogPost') {
      this.router.navigateByUrl(`/blog/${pod?.blogId}/detail`);
    }
    else if (pod?.podType === 'customLink' && !pod?.iframeCustomLink) {
      window.open(pod?.about, '_blank');
    }
    else if (pod?.podType === 'internalLink') {
      this.router.navigateByUrl(pod.about);
    }
    else if (pod?.podType === 'customLink' && pod?.iframeCustomLink) {
      this.router.navigateByUrl(`/customLink/${pod?.id}`);
    }
    else if (pod?.podType === 'internalLink') {
      this.router.navigateByUrl(`/${pod?.about}`);
    }
    else if (pod?.podType === 'urlIntegration' && !pod?.iframeCustomLink) {
      // Em mobile/navegador in-app o Safari bloqueia window.open de NOVA ABA;
      // o connector já redireciona na mesma aba, então navegamos same-tab.
      // No desktop mantém a nova aba.
      if (window.innerWidth < 992) {
        this.router.navigateByUrl(`/connector/${pod?.id}`);
      } else {
        window.open(`/connector/${pod?.id}`, '_blank');
      }
    }
    else if (pod?.podType === 'urlIntegration' && pod?.iframeCustomLink) {
      this.router.navigateByUrl(`/connector/${pod?.id}/iframe`);
    }
  }

  getCurrentChatUserAvailabilityStatus() {
    this.cs.getCurrentChatUserAvailabilityStatus().subscribe((data: any) => {
      if (data && data.userId > 0) {
        this.cs.currentChatUserAvailabilityStatus = data;
        this.observeCurrentChatAvailabilityExpiration();
      } else {
        // Setar status padrão(sempre o primeiro da ordem) caso não haja um status definido
        this.cs.chatUserAvailabilityList().subscribe((data: any) => {
          if (data) {
            this.chatAvailabilityStatusList = data;
            this.cs.currentChatUserAvailabilityStatus = {
              userId: this.menu.loggedUserId,
              chatAvailabilityStatus: this.chatAvailabilityStatusList[0],
              customMessage: null,
              expiresOn: null,
              updatedOn: new Date()
            };
            this.observeCurrentChatAvailabilityExpiration();
            this.cs.setChatUserAvailability(this.cs.currentChatUserAvailabilityStatus?.chatAvailabilityStatus?.id, null, null).subscribe();
          } else {
            this.chatAvailabilityStatusList = [];
          }
          this.cdr.markForCheck();
        }, err => {
          this.chatAvailabilityStatusList = [];
          this.cdr.markForCheck();
        });
      }
      this.cdr.markForCheck();
    }, err => {
      this.cs.currentChatUserAvailabilityStatus = null;
      this.observeCurrentChatAvailabilityExpiration();
      this.cdr.markForCheck();
    });
  }

  private observeCurrentChatAvailabilityExpiration(): void {
    this.clearChatAvailabilityExpirationObserver();

    const expiresOn = this.cs.currentChatUserAvailabilityStatus?.expiresOn;
    if (!expiresOn) {
      return;
    }

    const expiresAt = new Date(expiresOn).getTime();
    if (Number.isNaN(expiresAt)) {
      return;
    }

    const msUntilExpiration = expiresAt - Date.now();

    if (msUntilExpiration <= 0) {
      this.handleExpiredChatAvailabilityStatus();
      return;
    }

    this.chatAvailabilityExpirationSubscription = timer(msUntilExpiration).subscribe(() => {
      this.handleExpiredChatAvailabilityStatus();
      this.cdr.markForCheck();
    });
  }

  private clearChatAvailabilityExpirationObserver(): void {
    if (this.chatAvailabilityExpirationSubscription) {
      this.chatAvailabilityExpirationSubscription.unsubscribe();
      this.chatAvailabilityExpirationSubscription = null;
    }
  }

  private handleExpiredChatAvailabilityStatus(): void {
    const expiresOn = this.cs.currentChatUserAvailabilityStatus?.expiresOn;
    if (!expiresOn) {
      return;
    }

    const expiresAt = new Date(expiresOn).getTime();
    if (Number.isNaN(expiresAt) || expiresAt > Date.now()) {
      this.observeCurrentChatAvailabilityExpiration();
      return;
    }

    this.setChatAvailabilityStatusToDefault();
  }

  private setChatAvailabilityStatusToDefault(): void {
    const applyDefaultStatus = (statusList: any[]): void => {
      const defaultStatus = statusList?.length ? statusList[0] : null;
      if (!defaultStatus) {
        return;
      }

      this.cs.currentChatUserAvailabilityStatus = {
        userId: this.menu.loggedUserId,
        chatAvailabilityStatus: defaultStatus,
        customMessage: null,
        expiresOn: null,
        updatedOn: new Date()
      };

      this.observeCurrentChatAvailabilityExpiration();
      this.cs.setChatUserAvailability(defaultStatus.id, null, null).subscribe();
    };

    if (this.chatAvailabilityStatusList?.length) {
      applyDefaultStatus(this.chatAvailabilityStatusList);
      return;
    }

    this.cs.chatUserAvailabilityList().subscribe((data: any) => {
      this.chatAvailabilityStatusList = data || [];
      applyDefaultStatus(this.chatAvailabilityStatusList);
      this.cdr.markForCheck();
    }, _err => {
      this.clearChatAvailabilityExpirationObserver();
      this.cdr.markForCheck();
    });
  }

  async listChatUserAvailabilityStatuses() {
    const data = await this.cs.chatUserAvailabilityList().toPromise();
    if (data) {
      this.chatAvailabilityStatusList = data;
    } else {
      this.chatAvailabilityStatusList = [];
    }
  }

  async openChatAvailabilityStatusModal(): Promise<void> {
    await this.listChatUserAvailabilityStatuses();

    const current = this.cs.currentChatUserAvailabilityStatus;

    this.selectedChatUserAvailabilityStatus = current?.chatAvailabilityStatus || null;
    // Se o status atual for o default (primeiro da lista), não exibir nem manter mensagem/expiração
    if (this.isDefaultAvailabilitySelected()) {
      this.selectedChatUserAvailabilityCustomMessage = '';
      this.clearExpires();
      this.editStatusModal.show();
      return;
    }

    this.selectedChatUserAvailabilityCustomMessage = current?.customMessage || '';
    const expires = current?.expiresOn ? new Date(current.expiresOn) : null;
    this.selectedChatUserAvailabilityExpiresOn = expires;

    this.expiresPreset = null;
    this.selectedChatUserAvailabilityExpiresDate = null;
    this.selectedChatUserAvailabilityExpiresTime = null;

    if (expires) {
      const now = new Date();
      const diffMs = expires.getTime() - now.getTime();
      const diffMin = Math.round(diffMs / 60000);

      if (diffMin >= 8 && diffMin <= 12) {
        this.expiresPreset = '10m';
      } else if (diffMin >= 55 && diffMin <= 65) {
        this.expiresPreset = '1h';
      } else if (diffMin >= 115 && diffMin <= 125) {
        this.expiresPreset = '2h';
      } else if (this.isEndOfDay(expires)) {
        this.expiresPreset = 'eod';
      } else {
        this.expiresPreset = 'custom';
      }

      this.selectedChatUserAvailabilityExpiresDate = expires;
      this.selectedChatUserAvailabilityExpiresTime = expires;
    }

    this.editStatusModal.show();
  }

  private isEndOfDay(d: Date): boolean {
    return d.getHours() === 23 && d.getMinutes() === 59;
  }

  isDefaultAvailabilitySelected(): boolean {
    const first = this.chatAvailabilityStatusList?.length ? this.chatAvailabilityStatusList[0] : null;
    if (!first) {
      return false;
    }
    return !!this.selectedChatUserAvailabilityStatus && this.selectedChatUserAvailabilityStatus.id === first.id;
  }

  onSelectChatAvailabilityStatus(status: any): void {
    this.selectedChatUserAvailabilityStatus = status;

    if (this.isDefaultAvailabilitySelected()) {
      this.selectedChatUserAvailabilityCustomMessage = '';
      this.clearExpires();
    }
  }

  onExpiresPresetChange() {
    if (this.isDefaultAvailabilitySelected()) {
      this.clearExpires();
      return;
    }
    if (!this.expiresPreset) {
      this.clearExpires();
      return;
    }

    if (this.expiresPreset === 'custom') {
      const base = this.selectedChatUserAvailabilityExpiresOn
        ? new Date(this.selectedChatUserAvailabilityExpiresOn)
        : new Date();

      this.selectedChatUserAvailabilityExpiresDate = new Date(base);
      this.selectedChatUserAvailabilityExpiresTime = new Date(base);
      this.updateCustomExpiresOn();
      return;
    }

    const now = new Date();
    const expires = new Date(now);

    switch (this.expiresPreset) {
      case '10m':
        expires.setMinutes(expires.getMinutes() + 10);
        break;
      case '1h':
        expires.setHours(expires.getHours() + 1);
        break;
      case '2h':
        expires.setHours(expires.getHours() + 2);
        break;
      case 'eod':
        expires.setHours(23, 59, 59, 999);
        break;
    }

    this.selectedChatUserAvailabilityExpiresOn = expires;

    this.selectedChatUserAvailabilityExpiresDate = null;
    this.selectedChatUserAvailabilityExpiresTime = null;
  }

  updateCustomExpiresOn() {
    if (!this.selectedChatUserAvailabilityExpiresDate) {
      this.selectedChatUserAvailabilityExpiresOn = null;
      return;
    }

    const d = new Date(this.selectedChatUserAvailabilityExpiresDate);

    const t = this.selectedChatUserAvailabilityExpiresTime;
    const hh = t ? t.getHours() : 9;
    const mm = t ? t.getMinutes() : 0;

    d.setHours(hh, mm, 0, 0);
    this.selectedChatUserAvailabilityExpiresOn = d;
  }

  clearExpires() {
    this.expiresPreset = null;
    this.selectedChatUserAvailabilityExpiresOn = null;
    this.selectedChatUserAvailabilityExpiresDate = null;
    this.selectedChatUserAvailabilityExpiresTime = null;
  }

  setMinAllowedDate() {
    const minDate = new Date();
    minDate.setDate(minDate.getDate());
    return minDate;
  }

  saveChatUserAvailabilityStatus(): void {
    if (this.expiresPreset === 'custom') {
      this.updateCustomExpiresOn();
    }

    const statusId = this.selectedChatUserAvailabilityStatus?.id || null;

    const isDefault = this.isDefaultAvailabilitySelected();

    const message = isDefault ? null : ((this.selectedChatUserAvailabilityCustomMessage || '').trim() || null);

    const expiresOn = isDefault ? null : (this.expiresPreset ? this.selectedChatUserAvailabilityExpiresOn : null);

    this.cs.setChatUserAvailability(statusId, message, expiresOn).subscribe((data: any) => {
      if (data) {
        this.cs.currentChatUserAvailabilityStatus = {
          userId: this.menu.loggedUserId,
          chatAvailabilityStatus: this.selectedChatUserAvailabilityStatus,
          customMessage: message,
          expiresOn: expiresOn,
          updatedOn: new Date()
        };
        this.observeCurrentChatAvailabilityExpiration();
      }
      this.editStatusModal.hide();
      this.cdr.markForCheck();
    }, _err => {
        this.editStatusModal.hide();
        this.errorModal.show();
        this.cdr.markForCheck();
      }
    );
  }

}
